import { useEffect } from 'react'

import { useGenerationStatus } from 'Pods/Shared/GenerationStatus'
import { clearGenerationResultForRun } from 'Pods/Shared/GenerationStatus/actions'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const selectOpenedModelId = (state) => state.ui?.openedModel?.id ?? null
const selectLastResults = (state) => state.lastResults || EMPTY_ARRAY

// Marks a finished run "reviewed" the moment its model is opened in the studio: when the
// model on screen matches a run behind the global "model ready" notifications, clear that
// run's result so the top-nav checkmark, its Create-with-AI dropdown row and the toast
// disappear - and stay gone, since the removal persists to localStorage. Other stacked
// results survive. Covers both open paths: reopening an existing model (URL/library ->
// setOpenedModel) and a fresh in-studio completion (which opens the model, then records
// the result), as it reacts to either id.
const useClearReviewedOnOpen = () => {
  const openedModelId = useThreeDStudioStore(selectOpenedModelId)
  const lastResults = useGenerationStatus(selectLastResults)

  useEffect(() => {
    if (openedModelId == null || lastResults.length === 0) {
      return
    }

    const reviewed = lastResults.find((result) => String(result?.runId) === String(openedModelId))
    if (reviewed) {
      clearGenerationResultForRun(reviewed.runId)
    }
  }, [openedModelId, lastResults])
}

export default useClearReviewedOnOpen
